module.exports = __webpack_public_path__ + "static/img/18036C_2_3_R_20200723_fit.9bec9f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18036C_2_3_R_20200723_fit.png
// module id = WM6c
// module chunks = 0